type TLocationChangeListener = () => void;

const listeners = new Set<TLocationChangeListener>();

let stopListening: (() => void) | undefined;

function notifyListeners() {
  [...listeners].forEach(listener => listener());
}

function startListening() {
  const originalPushState = window.history.pushState;
  const originalReplaceState = window.history.replaceState;
  let isActive = true;

  const patchedPushState: History['pushState'] = (data, unused, url) => {
    originalPushState.call(window.history, data, unused, url);
    if (isActive) {
      notifyListeners();
    }
  };
  const patchedReplaceState: History['replaceState'] = (data, unused, url) => {
    originalReplaceState.call(window.history, data, unused, url);
    if (isActive) {
      notifyListeners();
    }
  };

  window.history.pushState = patchedPushState;
  window.history.replaceState = patchedReplaceState;
  window.addEventListener('popstate', notifyListeners);

  return () => {
    isActive = false;
    window.removeEventListener('popstate', notifyListeners);
    if (window.history.pushState === patchedPushState) {
      window.history.pushState = originalPushState;
    }
    if (window.history.replaceState === patchedReplaceState) {
      window.history.replaceState = originalReplaceState;
    }
  };
}

export function subscribeToLocationChange(listener: TLocationChangeListener): () => void {
  const subscription = () => listener();
  listeners.add(subscription);

  if (!stopListening) {
    stopListening = startListening();
  }

  return () => {
    if (!listeners.delete(subscription) || listeners.size > 0) {
      return;
    }

    stopListening?.();
    stopListening = undefined;
  };
}
